























import VueOptions from '@utils/VueOptions'
import LogoSelector from '@ui/LogoSelector'

settings =
  name: 'BrandInfoForm'
  components: { LogoSelector }

  vue:
    props: ['item', 'mode']

    computed:
      initialSelectedLogo: ->
        domain: @item.domain
        name: @item.name
        logo: @item.logo

    methods:
      hiSelectLogo: (brand) ->
        @item.logo = brand.logo
        @item.domain = brand.domain
        @item.name = brand.name

export default VueOptions.vue settings
